import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  additionalInfoPageView: 'default',
  brandAvatarUrl: '',
  brandBannerUrl: '',
  cardImageUrl: '',
};

const marketplaceSlice = createSlice({
  name: 'marketplace',
  initialState,
  reducers: {
    setAdditionalInfoPageView: (state, action) => {
      return { ...state, additionalInfoPageView: action.payload };
    },
    setBrandAvatarUrl: (state, action) => {
      return { ...state, brandAvatarUrl: action.payload };
    },
    setBrandBannerUrl: (state, action) => {
      return { ...state, brandBannerUrl: action.payload };
    },
    setCardImageUrl: (state, action) => {
      return { ...state, cardImageUrl: action.payload };
    },
  },
});

export default marketplaceSlice.reducer;
